import React, { useState, useEffect, Suspense } from "react";
import "./Banner.scss";

import AnimatedText from "./AnimatedText";
import Button from "../Button/";
import * as dataJSON from "../../Data/Banner.json";
const Video = React.lazy(() => import("./Video"));

export default ({ lang }) => {
    const [data, setData] = useState(dataJSON.default[lang]);
    const media = document.documentElement.clientWidth + 17;

    useEffect(() => {
        setData(dataJSON.default[lang]);
    }, [lang]);

    function BannerPC() {
        return (
            <div className="banner banner_pc">
                <Suspense fallback="">
                    <Video data={data} lang={lang} />
                </Suspense>
            </div>
        );
    }
    function BannerMobile() {
        return (
            <div className="banner banner_mob">
                <div className="container">
                    {/* <ScrollEffect /> */}
                    <h1>{data.h1}</h1>
                    <h2>{data.h2}</h2>
                    <AnimatedText texts={data.texts} />
                </div>
            </div>
        );
    }

    return (
        <>
            {media > 767 && <BannerPC />}
            {media < 768 && <BannerMobile />}
        </>
    );
};
